// extracted by mini-css-extract-plugin
export var section = "styles-module--section--i6tn6";
export var container = "styles-module--container--DccyE";
export var tagline = "styles-module--tagline--PBjGk";
export var title = "styles-module--title--xMhUZ";
export var content = "styles-module--content--5LZN4";
export var cta = "styles-module--cta--Z1ijq";
export var backAndForthRight = "styles-module--backAndForthRight--Bc+jU";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--wvQaI";
export var animateBg = "styles-module--animateBg--JGw9D";